import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import {
  ComposedChart,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Line,
  Text,
} from "recharts";
import { AmountFormatted, formatDate, formatDateXAxis } from "./util";

export default function GroupBiaxialBarChart({
  colors,
  stayData,
  fullScreen,
  currency,
}) {
  const [maxHeight, setMaxHeight] = useState(1);
  useEffect(() => {
    var height = 1;
    stayData.map((item) => {
      if (item?.revenue > height) {
        height = item?.revenue;
      }
    });
    setMaxHeight(Math.ceil(height));
    // console.log("height", Math.ceil(height));
  }, [stayData]);

  const [graphWidth, setGraphWidth] = useState();
  useEffect(() => {
    var screenWidth =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    if (fullScreen) {
      setGraphWidth(Math.round((screenWidth * 44) / 100));
    } else {
      setGraphWidth(Math.round((screenWidth * 35) / 100));
    }
  }, [fullScreen]);

  return (
    <ComposedChart
      width={graphWidth}
      height={300}
      data={stayData}
      margin={{
        top: 20,
      }}
    >
      {stayData.length < 1 && <CartesianGrid strokeDasharray="3 3" />}
      {stayData.length < 1 && (
        <g transform={`translate(${graphWidth / 2},${300 / 2})`}>
          <Text textAnchor="middle" verticalAnchor="middle">
            No data available
          </Text>
        </g>
      )}
      <XAxis
        dataKey="date"
        padding={{ left: 30, right: 30 }}
        tick={{ fontSize: 12, fill: "black", angle: -15, textAnchor: "end" }}
        tickFormatter={formatDateXAxis}
      />

      <YAxis
        domain={[0, maxHeight]}
        yAxisId="left"
        orientation="left"
        stroke={colors[5]}
        label={{
          value: `Amount (${localStorage.getItem("hotelCurrency")})`,
          angle: -90,
          position: "insideLeft",
        }}
        tickFormatter={AmountFormatted}
      />

      {/* <YAxis
        yAxisId="right"
        orientation="right"
        stroke={colors[4]}
        label={{
          value: "Rooms sold (Number)",
          angle: -90,
          position: "insideRight",
        }}
      /> */}
      <Tooltip
        content={<CustomTooltip currency={currency} />}
        cursor={{ fill: "transparent" }}
      />
      {/* <Legend /> */}
      <Bar yAxisId="left" dataKey="Revenue" fill={colors[3]} />
      {/* <Line
        type="monotone"
        dataKey="Room sold"
        stroke={colors[4]}
        yAxisId="right"
      /> */}
    </ComposedChart>
  );
}

const CustomTooltip = ({ active, payload, label, currency }) => {
  if (active && payload && payload.length) {
    return (
      <div className="custom-tooltip">
        <p className="label">{`${formatDate(label)}`}</p>
        <div>
          {payload.map((pld) => (
            <div style={{ display: "inline-block", padding: 5 }}>
              <div style={{ color: "black" }}>
                {pld?.dataKey} : {currency} {pld?.value}
              </div>
              {/* <div style={{ color: "gray" }}> drivers</div> */}
            </div>
          ))}
        </div>
      </div>
    );
  }

  return null;
};
